export const API_ADMIN_GET_CACHE = "API_ADMIN_GET_CACHE";
export const API_ADMIN_FLUSH_CACHE = "API_ADMIN_FLUSH_CACHE";
